import { createAction } from '@reduxjs/toolkit';
import {
  ERROR_MESSAGES,
  FETCH_SOCIAL_INTERNET_DATA,
  SET_SOCIAL_INTERNET_VALUES,
  SWITCH_SOCIAL_INTERNET_POPUP_VISIBLE,
} from '../../constants';
import { getObjectFromHref } from '../../utils/getObjectFromHref';
import { connectSocialInternetRequest, getPopupSocialInternetRequest } from '../../api/requests';

export const fetchSocialInternetData = createAction(FETCH_SOCIAL_INTERNET_DATA);
export const switchSocialInternetPopupVisible = createAction(SWITCH_SOCIAL_INTERNET_POPUP_VISIBLE);
export const setSocialInternetValues = createAction(SET_SOCIAL_INTERNET_VALUES);

export const getAccessToTheSocialInternet = () => (dispatch) => getPopupSocialInternetRequest()
  .then(({ data }) => data)
  .then(({ isSucceeded, result }) => {
    if (isSucceeded && result) {
      dispatch(fetchSocialInternetData(result));
    }
  }).catch((err) => {
    dispatch(setSocialInternetValues({
      isChecked: false,
      isLoading: false,
      error: ERROR_MESSAGES.SOMETHING_WENT_WRONG,
    }));

    console.error(err);
  });

const fetchSocialInternet = (socialInternetResponse) => (dispatch) => (
  connectSocialInternetRequest(socialInternetResponse)
    .then((resp) => resp.data)
    .then(({ isSucceeded, result }) => {
      if (isSucceeded && result) {
        window.location.hash = '/internet';
        dispatch(fetchSocialInternetData(result));
      }
    })
    .catch((err) => {
      console.error(err);
      dispatch(setSocialInternetValues({ isLoading: false, error: ERROR_MESSAGES.SOMETHING_WENT_WRONG }));
    })
);

export const switchSocialInternetCard = ({ target: { checked } }) => (dispatch) => {
  if (!checked) return;

  dispatch(setSocialInternetValues({ isLoading: true, isDisabled: true, error: null }));
  dispatch(getAccessToTheSocialInternet())
    .then(() => {
      dispatch(switchSocialInternetPopupVisible());
      dispatch(setSocialInternetValues({ isLoading: false, isDisabled: false }));
    });
};

export const onInitFetchingSocialInternetData = () => (dispatch) => {
  const socialInternetResponse = getObjectFromHref(window?.location?.href);

  if (!socialInternetResponse) return;

  dispatch(fetchSocialInternet(socialInternetResponse))
    .then(() => {
      dispatch(setSocialInternetValues({ isChecked: true }));
      dispatch(switchSocialInternetPopupVisible());
    });
};
